import { Slider } from 'radix-ui'
import { ReactNode, useMemo, useRef } from 'react'

export interface WidgetInputGradientProps {
	leftOffset: number
	rightOffset: number

	onChange: (leftOffset: number, rightOffset: number) => void

	leftColor: string
	rightColor: string

	leftChildren: ReactNode
	rightChildren: ReactNode
}

export function WidgetInputGradient({
	leftOffset,
	rightOffset,
	onChange,
	leftColor,
	rightColor,
	leftChildren,
	rightChildren,
}: WidgetInputGradientProps) {
	const constraintsRef = useRef(null)

	const shouldFlip = useMemo(() => {
		return Math.abs(leftOffset - rightOffset) < 0.2
	}, [leftOffset, rightOffset])

	return (
		<div className="py-4">
			<Slider.Root
				className="relative flex items-center select-none touch-none w-full h-5"
				value={[leftOffset, rightOffset]}
				step={0.01}
				max={1}
				minStepsBetweenThumbs={0.01}
				onValueChange={(value) => {
					onChange(value[0], value[1])
				}}
			>
				<Slider.Track className="bg-gray-100 rounded-full relative flex-grow h-2">
					<Slider.Range
						className="absolute rounded-full h-full"
						style={{ background: `linear-gradient(to right, ${leftColor}, ${rightColor})` }}
					/>
				</Slider.Track>
				<Slider.Thumb className="block w-5 h-5 bg-white border-2 border-blue-500 rounded-full hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-2 cursor-pointer" />
				<Slider.Thumb className="block w-5 h-5 bg-white border-2 border-blue-500 rounded-full hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-2 cursor-pointer" />
			</Slider.Root>

			<div className="relative grid">
				<>
					<div
						className="[grid-area:1/1] flex"
						style={{ transform: `translateX(${leftOffset * 100}%)` }}
					>
						<div style={{ transform: shouldFlip ? 'translateX(-100%)' : 'translateX(0%)' }}>
							{leftChildren}
						</div>
					</div>
					<div
						className="[grid-area:1/1] flex  pointer-events-none"
						style={{ transform: `translateX(-${(1 - rightOffset) * 100}%)` }}
					>
						<div className="grow-1" />
						<div
							className="pointer-events-auto"
							style={{ transform: shouldFlip ? 'translateX(100%)' : 'translateX(0%)' }}
						>
							{rightChildren}
						</div>
					</div>
				</>
			</div>
		</div>
	)
}
